export default {
  USER_ROLE: {
    operator: 'operator',
    supervisor: 'supervisor',
  },
}
